import GameStateControl from "../GameStateControl.js";
import State from "../State";
import ActiveBonusesView from "./bonuses/ActiveBonusesView.js";
import Page from "./framework/Page";
import ParentView from "./framework/ParentView";
import BottomRowContainer from "./main/bottom/BottomRowContainer";
import TopRowContainer from "./main/top/TopRowContainer";
import PopupViewController from "./menu/PopupViewController";
import { PageIds } from "./PageIds";
import PopupContainer from "./popup/PopupContainer";
import PrimaryUpgradePanel from "./upgrades/PrimaryUpgradePanel";

export default class GameViewOverlay extends ParentView {
    /**
     * @param {string} parentId
     * @param {State} state
     * @param {GameStateControl} gameStateControl 
     * @param {PopupViewController} popupViewController
     */
    constructor(parentId, state, gameStateControl, popupViewController) {
        super(parentId, PageIds.GAME_VIEW_OVERLAY_CONTAINER);

        const elementId = this.getElementId();

        ///////////////////////////
        // Top row
        ///////////////////////////

        this.addView(new TopRowContainer(elementId, 'topRowContainer', state.totals, state.partyTarget, state.runStatistics));

        // ///////////////////////////
        // // Active Skills Panel
        // ///////////////////////////

        // this.addView(new ActiveSkillsView(elementId, state.activeSkillTree));
        this.addView(new ActiveBonusesView(elementId, state.bonusCollection));

        ///////////////////////////
        // Popup Views
        ///////////////////////////

        this.addView(new PopupContainer(elementId, 'popupContainer', state.runStatistics, state.globalStatistics, 
            state.totals, state.gameOptions, gameStateControl, state.offlineLogic, popupViewController));

        ///////////////////////////
        // Upgrade Panel
        ///////////////////////////

        this.addView(new PrimaryUpgradePanel(elementId, state.minedUpgradeCollection, state.automationManager.minedUpgradeAutomation, 
            state.pickUpgradeCollection, state.automationManager.pickUpgradeAutomation, state.goldUpgradeCollection, state.automationManager.prestigeAutomation, 
            popupViewController));

        ///////////////////////////
        // Bottom row
        ///////////////////////////

        this.addView(new BottomRowContainer(elementId, 'bottomRowContainer', state.damage, 
            state.values, state.partyTarget, state.mineControl, state.crew, state.projection, state.panAnimation, state.runStatistics));

    }

    /**
     * @override
     */
    initializeView() {
        // <div id="gameViewOverlayContainer" class="view-overlay-container"></div>

        const parent = Page.getElement(this.parentId);
        Page.createElement('div', parent, this.elementId, 'view-overlay-container');

        this.setInitialVisibility(true);

        super.initializeView();
    }
}